
import ogPagesMixins from '@/mixins/ogPagesMixins'
export default {
  mixins: [ogPagesMixins],
  scrollToTop: true,
  async asyncData({ $axios }) {
    try {
      const [{ products }, groups] = await Promise.all([
        $axios.$get('/streams/products'),
        $axios.$get('/group/products'),
      ])

      return {
        products,
        groups,
      }
    } catch (error) {
      console.log(error)
    }
  },
  data() {
    return {
      seoTitle: 'Обзоры популярных сервисов и продуктов | Мегасреда',
      seoDescription:
        'Работа любого специалиста невозможна без использования специальных продуктов. Эти сервисы упрощают и ускоряют работу, помогают получить качественный результат. В этом разделе вы найдёте информацию о сервисах, которые специалисты используют в работе',
      seoH1: 'Обзоры продуктов и сервисов используемых специалистами в работе.',
      seoImage: {
        url: 'https://megasreda.ru/img/products/products_ogg.jpg',
        urlVk: 'https://megasreda.ru/img/products/products_ogg-vk.jpg',
        urlTw: 'https://megasreda.ru/img/products/products_ogg.jpg',
        type: 'image/jpeg',
        width: 1200,
        height: 630,
      },
      products: null,
      currentGroup: null,
      isVisibleAllGroups: false,
    }
  },
  computed: {
    productsFromGroup() {
      if (!this.currentGroup) {
        return this.products
      } else {
        const productIdsInGroup = this.groups
          ?.find((group) => group._id === this.currentGroup)
          .items?.map((item) => item.entity?._id)
        return this.products.filter((product) =>
          productIdsInGroup.includes(product._id)
        )
      }
    },
  },
  methods: {
    async fetchProducts() {
      try {
        const { products } = await this.$axios.$get('/streams/products')
        this.products = products
      } catch (error) {
        console.log(error)
      }
    },
  },
}
